// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipes_recipe__3eFSW"};